@import '~style-sheet-helpers/core.less';

.pill {
  margin: 6px 5px 6px 0;
}
